import axios from 'axios';
import { Question, QuestionForm, RubriqueWithQuestion, Tag } from 'core/models';

export type FaqFilters = {
    search?: string;
    tags?: number[];
};

export function getFaqs(filters?: FaqFilters) {
    return axios.get<Question[]>('/faqs/', {
        params: {
            tags: filters?.tags && filters.tags.length ? JSON.stringify(filters?.tags) : undefined,
            search: filters?.search || undefined,
        },
    });
}

export function getFaq(id: number) {
    return axios.get<Question>(`/faqs/${id}/`);
}

// TODO: à voir si encore nécessaire une fois l'api stabilisée...
const toExpectedQuestionData = (question: QuestionForm) => ({
    ...question,
    rubriqueOrder: 1,
    tags: question.tags?.reduce(
        (prev, tag, idx) => ({
            ...prev,
            [idx.toString()]: tag,
        }),
        {},
    ),
});

export function createFaq(faq: QuestionForm) {
    return axios.post('/faqs/', toExpectedQuestionData(faq));
}

export function editFaq(id: number, faq: QuestionForm) {
    return axios.put(`/faqs/edit/${id}/`, toExpectedQuestionData(faq));
}

export function deleteFaq(id: number) {
    return axios.delete(`/faqs/remove/${id}/`);
}

export function getFaqTags(id: number) {
    return axios.get<Tag[]>(`/faqs/${id}/tags/`);
}

export function getRubriquesWithFaqs(filters?: FaqFilters) {
    return getFaqs(filters).then((questions) =>
        (questions as Question[]).reduce((result: any, question) => {
            let rubrique = result.find((r) => r.id === question.rubrique.id);

            if (!rubrique) {
                rubrique = {
                    ...question.rubrique,
                    faqs: [],
                };
                result.push(rubrique);
            }

            rubrique.faqs.push(question);
            // A terme il y'a de fortes chances que ce soit trier côté back plutôt
            rubrique.faqs.sort((a, b) => a.faq.sortOrder - b.faq.sortOrder);

            return result;
        }, [] as RubriqueWithQuestion[]),
    );
    // return axios.get<RubriqueWithQuestion[]>('/rubrique/faqs');
}

export function getFaqsByTag(id: number) {
    return axios.get<Question[]>(`/tags/${id}/faqs/`);
}
